import type { SupportedLocale } from '../i18n/i18n.no-deps'
import { displayDate } from './date.no-deps'
import { assumeExhaustion } from './typeHelpers.no-deps'
import { getRelativeTimeWindow } from './relativeTimeWindow.no-deps'

export function getRelativeTimeMessage(locale: SupportedLocale, date: Date, now: Date): string {
    const timeWindow = getRelativeTimeWindow(date, now)

    switch (timeWindow.type) {
        case 'Timestamp':
            return displayDate(locale, date)

        case 'DaysAgo':
            if (timeWindow.days === 1) {
                return window.i18n('shared:relativeTime.daysAgo.one')
            }
            return window.i18n('shared:relativeTime.daysAgo.other', { days: timeWindow.days })

        case 'HoursAgo':
            if (timeWindow.hours === 1) {
                return window.i18n('shared:relativeTime.hoursAgo.one')
            }

            return window.i18n('shared:relativeTime.hoursAgo.other', { hours: timeWindow.hours })

        case 'MinutesAgo':
            if (timeWindow.minutes === 1) {
                return window.i18n('shared:relativeTime.minutesAgo.one')
            }

            return window.i18n('shared:relativeTime.minutesAgo.other', { minutes: timeWindow.minutes })

        case 'LessThanAMinuteAgo':
            return window.i18n('shared:relativeTime.lessThanMinute')

        case 'AFewSecondsAgo':
            return window.i18n('shared:relativeTime.fewSeconds')

        case 'JustNow':
            return window.i18n('shared:relativeTime.justNow')

        case 'InSeconds':
            if (timeWindow.seconds === 1) {
                return window.i18n('shared:relativeTime.inSeconds.one')
            }

            return window.i18n('shared:relativeTime.inSeconds.other', { seconds: timeWindow.seconds })

        case 'InLessThanAMinute':
            return window.i18n('shared:relativeTime.inLessThanMinute')

        case 'InMinutes':
            if (timeWindow.minutes === 1) {
                return window.i18n('shared:relativeTime.inMinutes.one')
            }

            return window.i18n('shared:relativeTime.inMinutes.other', { minutes: timeWindow.minutes })

        case 'InHours':
            if (timeWindow.hours === 1) {
                return window.i18n('shared:relativeTime.inHours.one')
            }

            return window.i18n('shared:relativeTime.inHours.other', { hours: timeWindow.hours })

        case 'InDays':
            if (timeWindow.days === 1) {
                return window.i18n('shared:relativeTime.inDays.one')
            }
            return window.i18n('shared:relativeTime.inDays.other', { days: timeWindow.days })

        default:
            assumeExhaustion(timeWindow)
    }
}
